import React from "react";
import { ScrollFadeIn, ScrollFadeInStagger } from "../../../components/ScrollFadeIn";
//images
const cnn =
  "https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1654892541/Abundo%20Wealth%20Assets/public-site/home-page/as-seen-in-logos/cnn_ig7v9z.svg";
const bankRate =
  "https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1654892540/Abundo%20Wealth%20Assets/public-site/home-page/as-seen-in-logos/bankrate_ufydi6.svg";
const washingtonPost =
  "https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1654892539/Abundo%20Wealth%20Assets/public-site/home-page/as-seen-in-logos/washington_post_sckvxb.svg";
const nerdWallet =
  "https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1654892539/Abundo%20Wealth%20Assets/public-site/home-page/as-seen-in-logos/nerdwallet_jzoas4.png";
const vice =
  "https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1654892539/Abundo%20Wealth%20Assets/public-site/home-page/as-seen-in-logos/vice_izbhzn.svg";
const kiplinger =
  "https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1654892539/Abundo%20Wealth%20Assets/public-site/home-page/as-seen-in-logos/kiplinger_dvrz7o.svg";
const yahoo =
  "https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1654892539/Abundo%20Wealth%20Assets/public-site/home-page/as-seen-in-logos/yahoo_cvgags.png";
const usaToday =
  "https://res.cloudinary.com/abundo-wealth-assets/image/upload/v1654892539/Abundo%20Wealth%20Assets/public-site/home-page/as-seen-in-logos/usa_today_qsytld.svg";
//end images
const AsSeenIn = () => {
  return (
    <div className="flex flex-col items-center space-y-10   justify-center">
      {/* First line of As Seen In */}
      <div className="flex space-x-4 items-center justify-center w-full max-w-screen-2xl ">
        {/* <div className="h-px w-full bg-c-orange-abundo  "></div> */}
        <ScrollFadeIn>
          <h5 className="text-gray-800 text-lg italic min-w-max lato font-medium  tracking-widest">AS SEEN IN</h5>

        </ScrollFadeIn>
        {/* <div className="h-px w-full bg-c-orange-abundo"></div> */}
      </div>
      {/* Second line of As Seen In */}
      <ScrollFadeInStagger faster className="grid grayscale grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-5 gap-y-10 justify-items-center place-items-center px-5">
        {" "}
        <ScrollFadeIn>
          <img src={nerdWallet} className="h-8" alt="" />{" "}
        </ScrollFadeIn>
        <ScrollFadeIn>
          <img src={yahoo} className="h-10 " alt="" />{" "}
        </ScrollFadeIn>
        <ScrollFadeIn>
          <img src={usaToday} className="h-10 " alt="" />{" "}
        </ScrollFadeIn>

        <ScrollFadeIn>
          <img src={washingtonPost} className="h-10 flex" alt="" />{" "}
        </ScrollFadeIn>
      
        <ScrollFadeIn>
          <img src={cnn} className="h-10" alt="" />{" "}
        </ScrollFadeIn>
      </ScrollFadeInStagger>
      {/* Third Line of As Seen In */}
      {/* <div className="h-px w-full bg-c-orange-abundo max-w-screen-2xl"></div> */}
    </div>
  );
};

export default AsSeenIn;
